
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8 border-t-4 border-gray-700">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/fc68c73d6fb130e20d23ae3e1828ea6a.png" 
              alt="PCS Premier Contracting Services"
              className="w-auto max-w-[200px] h-auto mb-4"
            />
            <p className="text-white mb-4">
              Premier Contracting Services for dock construction, repair, plumbing, mechanical, and electrical work.
            </p>
            <p className="text-sm text-white">
              <strong>CSLB #1121944</strong><br />
              Licensed &amp; Insured
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-white">
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Dock Replacement
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Dock Repair
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Marine Plumbing Services
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Marine Mechanical Services
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Electrical Services
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Marine Construction
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-white">
              <li>
                <a href="#about" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-white">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-1"></i>
                <a href="tel:916-884-4818" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  916-884-4818
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-1"></i>
                <div>
                  <p>Mon-Fri: 7AM-5PM</p>
                  <p>Sat: 8AM-2PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-400 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white text-sm text-center md:text-left">
              &copy; {currentYear} PCS Marine Construction. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-white/60 hover:text-white text-xs transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl text-white"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-xl text-white"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                aria-label="Google"
              >
                <i className="ri-google-fill text-xl text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
